import React from "react";
import { X } from "lucide-react";

const TEMPLATE_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
];

const fieldStyle = {
  display: "grid",
  gridTemplateColumns: "230px minmax(0, 1fr)",
  alignItems: "center",
  minHeight: 48,
  borderBottom: "1px solid #f1f3f5",
  fontSize: 14,
};

const CrmV2MailTemplatePreviewModal = ({ open, template, lead, onClose }) => {
  const [language, setLanguage] = React.useState(template?.lang || "en");

  React.useEffect(() => {
    setLanguage(template?.lang || "en");
  }, [template]);

  if (!open || !template) return null;

  const resolve = (value) => String(value || "")
    .replace(/\{\{\s*lead\.name\s*\}\}/g, lead?.name || "-")
    .replace(/\{\{\s*lead\.email_from\s*\}\}/g, lead?.email_from || "-")
    .replace(/\{\{\s*lead\.partner_name\s*\}\}/g, lead?.partner_name || lead?.company || "-")
    .replace(/\{\{\s*lead\.stage_name\s*\}\}/g, lead?.stage_name || "-");

  return (
    <div style={styles.backdrop} role="dialog" aria-modal="true" aria-label="Template Preview">
      <div style={{ ...styles.dialog, maxWidth: 1180, minHeight: 620 }}>
        <div style={styles.header}>
          <strong>Template Preview</strong>
          <button type="button" onClick={onClose} style={styles.close} aria-label="Close"><X size={16} /></button>
        </div>
        <div style={styles.body}>
          <h3 style={styles.previewTitle}>Preview of {template.name || "template"}</h3>
          <div style={fieldStyle}><span>Choose an example Lead/Opportunity record:</span><strong>{lead?.name || "Current lead"}</strong></div>
          <div style={fieldStyle}><span>Force a language:</span><select value={language} onChange={(event) => setLanguage(event.target.value)} style={styles.languageSelect}>{TEMPLATE_LANGUAGES.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}</select></div>
          <div style={fieldStyle}><span>Subject</span><span>{resolve(template.subject) || "-"}</span></div>
          <div style={fieldStyle}><span>From</span><span>{template.from_email || "-"}</span></div>
          <div style={fieldStyle}><span>To</span><span>{lead?.email_from || "-"}</span></div>
          <div style={fieldStyle}><span>Cc</span><span>-</span></div>
          <div style={fieldStyle}><span>Reply-To</span><span>-</span></div>
          <div style={{ marginTop: 16, padding: "12px 0", color: "#343a40", fontSize: 13, lineHeight: 1.65 }} dangerouslySetInnerHTML={{ __html: resolve(template.body_html || template.body_text) || "Empty template body" }} />
        </div>
        <div style={styles.footer}>
          <button type="button" onClick={onClose} style={styles.linkButton}>CLOSE</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  backdrop: { position: "fixed", inset: 0, zIndex: 80, display: "flex", alignItems: "center", justifyContent: "center", padding: 12, background: "rgba(0,0,0,.52)" },
  dialog: { width: "min(1180px, 96vw)", maxHeight: "94vh", display: "flex", flexDirection: "column", background: "#fff", boxShadow: "0 16px 45px rgba(0,0,0,.32)", fontFamily: '"Lucida Grande", Helvetica, Verdana, Arial, sans-serif', color: "#343a40" },
  header: { minHeight: 56, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 20px", borderBottom: "1px solid #dee2e6", fontSize: 18 },
  close: { border: 0, background: "transparent", color: "#868e96", cursor: "pointer", display: "inline-flex", padding: 7 },
  body: { overflowY: "auto", padding: "26px 34px 34px" },
  previewTitle: { margin: "0 0 16px", fontSize: 20, fontWeight: 600 },
  footer: { display: "flex", alignItems: "center", minHeight: 62, padding: "0 20px", borderTop: "1px solid #dee2e6" },
  linkButton: { border: 0, background: "transparent", color: "#714b67", fontSize: 13, cursor: "pointer", padding: 0 },
  languageSelect: { width: "100%", border: 0, borderBottom: "1px solid #adb5bd", padding: "8px 3px", background: "#fff", color: "#343a40", fontSize: 14 },
};

export default CrmV2MailTemplatePreviewModal;
